// 📐 전체 화면 장표를 자막 띠 위에 앉히는 변환(#6119) — 장표 층(`Overlay169SlideLayer`)이 재고 계산해 내려보낸다(`slideCaptionFit`).
//   대부분의 장표는 장표 층이 바깥 상자째 변환한다. 모션 타이포는 화면 전체 바탕(그라데이션·입자)을 스스로 그려서
//   통째로 줄이면 가장자리가 비므로 «글자 칸»에만 이 값을 건다.
//   ★값이 없으면(null · 자막 윗선에 안 닿는 장면 · 무대·정밀 편집 밖) 종전 그대로★ — 기본값 null 이 바이트 불변의 근거다.
import { createContext, useContext } from 'react';

/** CSS transform(원점 0 0) — 예: `translate(0px,-120px) scale(0.86)`. */
export const SlideContentFitContext = createContext<string | null>(null);

/**
 * 📐 넘치는 장표의 «자리 짜기» 단계(#6119 2차) — 글자를 줄이기 전에 빈자리부터 쓴다.
 *   0 = 종전 · 1 = 촘촘히(칸 사이·안쪽 여백·최소 높이) · 2 = 한 줄로(16:9 카드 한 줄 · 한 문장 장표의 긴 목록 2열).
 *   장표 층이 단계마다 다시 재서 «그래도 넘칠 때만» 다음 단계로 · 마지막에만 글자를 줄인다. 기본 0 = 종전 그대로.
 */
export type SlideRoomLevel = 0 | 1 | 2;
export const SLIDE_ROOM_MAX: SlideRoomLevel = 2;
export const SlideRoomContext = createContext<SlideRoomLevel>(0);
export const useSlideRoom = (): SlideRoomLevel => useContext(SlideRoomContext);
